<script lang="ts">
  import Input from '$shared/atoms/Input/Input.svelte';
  import InputGroup from '$shared/atoms/InputGroup/InputGroup.svelte';
  import type { IAlias } from '$provider/lib/apis/interfaces/IResponse';
  import { onMount } from 'svelte';

  interface Props {
    value?: IAlias | null;
    onchange?: (formData: IAlias) => void;
  }

  let { value = null, onchange }: Props = $props();

  let formData: IAlias = $state({
    firstName: '',
    lastName: ''
  });

  onMount(() => {
    value && (formData = value);
  });

  const onDispatchChange = (): void => {
    onchange?.(formData);
  };

  const onInputChange = (key: keyof IAlias, detail: any): void => {
    formData[key] = detail?.value?.trim();
    onDispatchChange();
  };
</script>

<div class="name-input">
  <InputGroup>
    <Input
      placeholder="First name"
      value={formData.firstName}
      oninput={(e) => onInputChange('firstName', e)}
    />
    <Input
      placeholder="Last name"
      value={formData.lastName}
      oninput={(e) => onInputChange('lastName', e)}
    />
  </InputGroup>
</div>
